export const SITE = {
  name: "Mangalam Group",
  url: "https://mangalamgroup.net",
  description: "Mangalam Group brings together Mangalam Enterprises, Apex Infra and AMR — BKT tyre distribution, OTR & CVR tyres, and tyre management for mining in Jharkhand.",
  image: "https://mangalamgroup.net/assets/brand/og-image.png",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1622645636770-11fbf0611463?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxtaW5pbmclMjB0cnVja3xlbnwwfHx8fDE3OTEwMTUwMzR8MA&ixlib=rb-4.1.0&q=85",
  openPit: "https://images.unsplash.com/photo-1628487749130-2d41acb1802a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxtaW5pbmclMjB0cnVja3xlbnwwfHx8fDE3OTEwMTUwMzR8MA&ixlib=rb-4.1.0&q=85",
  loader: "https://images.unsplash.com/photo-1751054786365-4b02b690d301?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwyfHx3aGVlbCUyMGxvYWRlciUyMGV4Y2F2YXRvciUyMGVhcnRobW92aW5nJTIwY29uc3RydWN0aW9uJTIwdmVoaWNsZXxlbnwwfHx8fDE3OTEwMTUwMzR8MA&ixlib=rb-4.1.0&q=85",
  tread: "https://storage.googleapis.com/bkt-prod-storage/76c7864d-5aba-4fa2-8e1f-493fa6233877",
  flatbed: "https://storage.googleapis.com/bkt-prod-storage/0e1b61b1-3abf-4e61-84fc-e2ec73d7aae5",
  engineer: "https://images.unsplash.com/photo-1622645916455-aa13b87438ec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHw0fHxpbmR1c3RyaWFsJTIwdGVjaG5pY2lhbiUyMGVuZ2luZWVyJTIwbWluaW5nfGVufDB8fHx8MTc5MTAxNTAzNHww&ixlib=rb-4.1.0&q=85",
  machinery: "https://images.unsplash.com/photo-1578804376914-6d367cd21488?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwyfHxpbmR1c3RyaWFsJTIwdGVjaG5pY2lhbiUyMGVuZ2luZWVyJTIwbWluaW5nfGVufDB8fHx8MTc5MTAxNTAzNHww&ixlib=rb-4.1.0&q=85",
};

export const CONTACT = {
  phone: "+91 3264004712",
  phoneHref: "tel:+913264004712",
  email: "msmangalamenterprises@gmail.com",
  address: "Dhanbad, Jharkhand, India",
  whatsapp: "https://wa.me/918210078986",
};

export const BUSINESSES = [
  {
    slug: "mangalam-enterprises",
    name: "Mangalam Enterprises",
    badge: "Est. 2011",
    focus: "Industrial & CVR Tyres",
    accent: "#3B82F6",
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_industrial-tyre-hub/artifacts/o8hqn80p_image.png",
    blurb:
      "Industrial tyres and commercial vehicle radial tyres, backed by the BKT portfolio and a growing dealer network.",
  },
  {
    slug: "apex-infra",
    name: "Apex Infra",
    badge: "Est. 2022",
    focus: "Earthmoving & Off-Highway Tyres",
    accent: "#F59E0B",
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_industrial-tyre-hub/artifacts/uyqh7u25_image-1%20%283%29.jpeg",
    blurb:
      "Heavy-duty OTR and earthmoving tyres for large dump trucks, haulpacks and heavy mining equipment.",
  },
  {
    slug: "amr",
    name: "Apex Mineral Resources",
    short: "AMR",
    badge: "Est. 2026",
    focus: "Tyre Management & Mining Solutions",
    accent: "#10B981",
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_industrial-tyre-hub/artifacts/eidqygoc_image.png",
    blurb:
      "Technology-driven tyre lifecycle management, inspection and performance analytics for mining operations.",
  },
];
